export default __webpack_public_path__ + "static/media/screenshot3.8a5e1ca2.jpg";